import { startOfToday } from 'date-fns'

import type { DatePeriod, DateRange } from 'src/Types/DatePeriod'

/**
 * Checks if a date range is within today
 * @param dateRange - DateRange to check
 */
export const isDateRangeIncludingToday = (dateRange: DateRange) => dateRange.toDate > startOfToday().valueOf()

/**
 * Checks if the given (symbolic) date period has any value that includes now
 * @param datePeriod - DatePeriod to check
 */
export const isDatePeriodIncludingToday = (datePeriod: DatePeriod | undefined) =>
  datePeriod === 'lastHour' ||
  datePeriod === 'today' ||
  datePeriod === 'last24' ||
  datePeriod === 'lastDays' ||
  datePeriod === 'lastWeek' ||
  datePeriod === 'lastMonth'
